import { render, staticRenderFns } from "./UtaDashboard.vue?vue&type=template&id=19da3022&"
import script from "./UtaDashboard.vue?vue&type=script&lang=js&"
export * from "./UtaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UtaDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports